import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// importing components
import Header from './components/common/Header';
import Footer from './components/common/Footer';

import HomePage from './components/pages/home_page/HomePage';
import AboutUsPage from './components/pages/about_us_page/AboutUsPage';
import IndependentLivingPage from './components/pages/independ_living_page/IndependentLivingPage';


function App(){
  return (
    <Router>
        <Header/>

        <Routes>
          <Route path="/" element={<HomePage/>}/>
          <Route path="/about-us" element={<AboutUsPage/>}/>
          <Route path="/independent-living" element={<IndependentLivingPage/>}/>
        </Routes>

        <Footer/>
    </Router>
  )
}


export default App;